import { FC } from "react";
import { Box, Button, IconButton, Typography } from "@mui/material";
import {
  Link,
  Route,
  Routes,
  useLocation,
  useNavigate
} from "react-router-dom";
import {
  Add as AddIcon,
  ArrowBack as ArrowBackIcon,
  CheckCircle as CheckCircleIcon
} from "@mui/icons-material";
import { CounterpartyMenu } from "../../tradingCounterparties/counterParty/menu";
import { BrokerMenu } from "../../brokers/broker/menu";
import { canCreateMerger } from "../../../auth/permissions";
import { useRoles } from "../../../auth/useRoles";
import { MERGERS_PATH } from "../../../utils/entityPaths";

const MergersGridMenu: FC = () => {
  const roles = useRoles();
  const location = useLocation();
  const isCompletedPage = location.pathname.startsWith(
    `${MERGERS_PATH}/completed`
  );

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 2
      }}
    >
      <Typography sx={{ marginLeft: 1 }} variant="h5" component="span">
        {isCompletedPage ? "Completed Mergers" : "Mergers"}
      </Typography>
      {!isCompletedPage && (
        <Box display="flex" gap={1}>
          <Link to={`${MERGERS_PATH}/completed`}>
            <Button
              variant="outlined"
              startIcon={<CheckCircleIcon color="success" />}
            >
              Completed
            </Button>
          </Link>
          {/* Created, never requested: there is no Request / My requests pair here. */}
          {canCreateMerger(roles) && (
            <Link to={`${MERGERS_PATH}/new`}>
              <Button variant="contained" startIcon={<AddIcon />}>
                Onboard New Merger
              </Button>
            </Link>
          )}
        </Box>
      )}
    </Box>
  );
};

export const MergersMenu: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isOverview = /^\/mergers\/?$/.test(location.pathname);
  const isSignOff = /\/signoff\/?$/.test(location.pathname);

  const nav = () =>
    isOverview
      ? navigate("/home")
      : isSignOff
        ? navigate(-1)
        : navigate(MERGERS_PATH);

  return (
    <Box display="flex" width="100%">
      <IconButton onClick={nav} sx={{ color: "secondary.main" }}>
        <ArrowBackIcon />
      </IconButton>
      <Box display="flex" alignItems="center" width="100%" minWidth={0}>
        <Routes>
          <Route path="counterparty/:id/*" element={<CounterpartyMenu />} />
          <Route path="broker/:id/*" element={<BrokerMenu />} />
          <Route path="*" element={<MergersGridMenu />} />
        </Routes>
      </Box>
    </Box>
  );
};
